import React, { useMemo } from "react";
import { Chip, Stack, Typography } from "@mui/material";

import { HubTableTemplate, UserDetailIcon } from "../../components";
import { useGetLeads } from "../../hooks/react-query/useSalesData";
import { LEAD_STAGE_LABELS } from "../../constants/salesStages";

import SalesContextMenu from "../../containers/SalesKanban/SalesContextMenu";
import SalesEmpty from "../../containers/SalesKanban/SalesEmpty";

const items = [
  { id: "companyName", label: "Company" },
  { id: "contactName", label: "Contact" },
  { id: "stage", label: "Stage" },
  { id: "value", label: "Value" },
  { id: "assignee", label: "Owner" },
  { id: "createdAt", label: "Created" },
];

const keys = [
  { value: "companyName", defaultValue: "—" },
  { value: "contactName", defaultValue: "—" },
  {
    value: "stage",
    CustomComponent: ({ item }) => {
      const stage = LEAD_STAGE_LABELS.find((s) => s.id === item?.stage);
      return stage ? (
        <Chip
          variant="colorTag"
          flow={stage.flow}
          label={stage.label}
          size="small"
          sx={{ fontSize: 10, margin: "-2px 0px" }}
        />
      ) : null;
    },
  },
  { value: "value", isCurrency: true, defaultValue: 0 },
  {
    value: "assignee",
    CustomComponent: ({ item }) =>
      item?.assignee ? (
        <UserDetailIcon
          size={16}
          user={{ name: item.assignee.name, hueShift: item.assignee.id }}
          variant="rounded"
          includeName={item.assignee.name}
        />
      ) : (
        <Typography variant="caption" fontSize={10} color="text.disabled">
          —
        </Typography>
      ),
  },
  { value: "createdAt", isDate: true },
];

const LeadTableContextMenu = ({ item }) => (
  <SalesContextMenu itemId={item?.id} type="lead" />
);

export const SalesLeadsTable = () => {
  const { data, isLoading } = useGetLeads();

  const rows = useMemo(
    () => (data || []).flatMap((col) => col.elements),
    [data],
  );

  if (!isLoading && !rows.length) return <SalesEmpty type="lead" />;

  return (
    <Stack padding="15px" overflow="auto" flex={1}>
      <HubTableTemplate
        id="SalesLeadsTable"
        headerProps={{ items, includeEnd: true }}
        bodyProps={{ items: rows, keys, ContextMenu: LeadTableContextMenu }}
        isLoading={isLoading}
      />
    </Stack>
  );
};

export default SalesLeadsTable;
